(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5812],{

/***/ 13815:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/van-leasing/search",
      function () {
        return __webpack_require__(21503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ FaqAccordionItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
;// CONCATENATED MODULE: ./components/atomic/FaqAccordionItem/FaqAccordionItem.js






var FaqAccordionItem = function(param) {
    var item = param.item, isRequested = param.isRequested;
    var accordionItemRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ( true && isRequested) {
            setTimeout(function() {
                window.scrollTo(0, accordionItemRef.current.offsetTop);
            }, 400);
        }
    }, [
        isRequested
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
        triggerOnce: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: accordionItemRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                uuid: item.slug,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                            children: item.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                            children: item.body
                        })
                    })
                ]
            })
        })
    });
};
FaqAccordionItem.propTypes = {
    item: (prop_types_default()).object.isRequired,
    isRequested: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/atomic/FaqAccordionItem/index.ts



/***/ }),

/***/ 52488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(11783);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/Breadcrumbs.tsx







var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Breadcrumbs = function(param) {
    var crumbs = param.crumbs, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "".concat((breadcrumbs_module_default()).main, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            className: (breadcrumbs_module_default()).crumbs,
            children: [
                crumbs.length > 1 && crumbs.slice(0, crumbs.length - 1).map(function(crumb) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (breadcrumbs_module_default()).crumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                            icon: crumb.icon,
                            href: crumb.slug,
                            hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                            size: system/* Size.Small */.$u.Small,
                            children: crumb.label
                        })
                    }, crumb.slug);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "".concat((breadcrumbs_module_default()).crumb, " ").concat((breadcrumbs_module_default()).current),
                    "aria-current": "page",
                    children: [
                        crumbs[crumbs.length - 1].icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: crumbs[crumbs.length - 1].icon,
                            size: system/* Size.Small */.$u.Small
                        }),
                        crumbs[crumbs.length - 1].label
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/index.ts



/***/ }),

/***/ 40971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ SearchContentHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/styleguide/SearchContentHeader/search-content-header.module.scss
var search_content_header_module = __webpack_require__(85033);
var search_content_header_module_default = /*#__PURE__*/__webpack_require__.n(search_content_header_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./components/views/SearchBreadcrumbs/search-breadcrumbs.module.scss
var search_breadcrumbs_module = __webpack_require__(50997);
var search_breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(search_breadcrumbs_module);
// EXTERNAL MODULE: ./components/styleguide/Breadcrumbs/index.ts + 1 modules
var Breadcrumbs = __webpack_require__(52488);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
;// CONCATENATED MODULE: ./components/views/SearchBreadcrumbs/SearchBreadcrumbs.js





var SearchBreadcrumbs = function(param) {
    var pageContent = param.pageContent, isVans = param.isVans;
    var ref = (0,react.useState)([
        {
            icon: "ChevronLeft",
            label: isVans ? "Van leasing" : "Car leasing",
            slug: isVans ? routes/* ROUTES.vanSearchPage.url */.Z.vanSearchPage.url : routes/* ROUTES.carSearchPage.url */.Z.carSearchPage.url
        }, 
    ]), breadcrumbs = ref[0], setBreadcrumbs = ref[1];
    (0,react.useEffect)(function() {
        var crumbs = [];
        if (!!pageContent && !!pageContent.breadcrumbLabel1) {
            crumbs.push({
                label: pageContent.breadcrumbLabel1,
                slug: !!pageContent.breadcrumbUrlKey1 && !!pageContent.breadcrumbLabel2 ? "/".concat(pageContent.breadcrumbUrlKey1) : null
            });
            if (pageContent.breadcrumbLabel2) {
                crumbs.push({
                    label: pageContent.breadcrumbLabel2,
                    slug: null
                });
            }
        } else {
            crumbs.push({
                label: "".concat(isVans ? "Van " : "Car ", "Search"),
                slug: null
            });
        }
        setBreadcrumbs(crumbs);
    }, [
        pageContent,
        isVans
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
        hasPadding: false,
        className: (search_breadcrumbs_module_default()).main,
        crumbs: breadcrumbs
    });
};

;// CONCATENATED MODULE: ./components/views/SearchBreadcrumbs/index.js


// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/selectors/search.js
var selectors_search = __webpack_require__(29906);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/SearchContentHeader/SearchContentHeader.tsx

















var SearchContentHeader = function(param) {
    var pageContent = param.pageContent, isVans = param.isVans, _showBreadcrumbs = param.showBreadcrumbs, showBreadcrumbs = _showBreadcrumbs === void 0 ? true : _showBreadcrumbs, _showLinks = param.showLinks, showLinks = _showLinks === void 0 ? true : _showLinks, _isBottom = param.isBottom, isBottom = _isBottom === void 0 ? false : _isBottom;
    var ref;
    var ref1 = (0,react.useState)(false), isIntroContentFullyVisible = ref1[0], setIsIntroContentFullyVisible = ref1[1];
    var searchContent = (0,es/* useSelector */.v9)(selectors_search/* selectSearchResultDeals */.yw);
    var ref2 = (0,react.useState)(pageContent.extra ? pageContent.intro.concat("\n").concat(pageContent.extra) : pageContent.intro), content = ref2[0], setContent = ref2[1];
    (0,react.useEffect)(function() {
        setContent(pageContent.extra ? pageContent.intro.concat("\n").concat(pageContent.extra) : pageContent.intro);
    }, [
        pageContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!pageContent && !!((ref = searchContent[0]) === null || ref === void 0 ? void 0 : ref.range) && searchContent.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: '\n          {\n            "@context":"http://www.schema.org",\n            "@type":"Product",\n            "brand":"'.concat(searchContent[0].manufacturer, '",\n            "logo":"').concat(pageContent.image, '",\n            "name":"').concat(searchContent[0].manufacturer, " ").concat(searchContent[0].range, '",\n            "category":"').concat(searchContent[0].manufacturer, '",\n            "image":"').concat((0,vehicle/* getVehicleHeroImage */.Nk)(searchContent[0].profileImage), '",\n            "description":"').concat(searchContent[0].manufacturer, " ").concat(searchContent[0].range, ' offers, personal pricing inc. VAT.",\n            "offers":{\n              "@type":"AggregateOffer",\n              "lowPrice":"').concat(searchContent[0].profile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(searchContent[0].profile.price) : searchContent[0].profile.price.toFixed(2), '",\n              "priceCurrency":"GBP"\n            }\n          }\n        ')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: '\n          {\n            "@context":"http://schema.org",\n            "@type":"Car",\n            "name":"'.concat(searchContent[0].manufacturer, " ").concat(searchContent[0].range, '",\n            "aggregateRating":{\n                "@type":"AggregateRating",\n                "ratingValue":"').concat(searchContent[0].rating, '",\n                "bestRating":"100",\n                "ratingCount":"').concat(searchContent.length, '"\n            }\n          }\n        ')
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((search_content_header_module_default()).main, " ").concat(isBottom ? (search_content_header_module_default()).bottom : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (search_content_header_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_content_header_module_default()).content,
                            children: [
                                showBreadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBreadcrumbs, {
                                    isVans: isVans,
                                    pageContent: pageContent
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: !(0,utilities_system/* isProd */.BB)() ? "search-content__h1" : "",
                                    children: pageContent.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_content_header_module_default()).body,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                                            className: "".concat((search_content_header_module_default()).markdown, " ").concat(isIntroContentFullyVisible ? (search_content_header_module_default()).show : ""),
                                            children: content
                                        }),
                                        !isIntroContentFullyVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: (search_content_header_module_default()).button,
                                            onClick: function() {
                                                return setIsIntroContentFullyVisible(true);
                                            },
                                            children: "Read more"
                                        })
                                    ]
                                })
                            ]
                        }),
                        showLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_content_header_module_default()).links,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_content_header_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (search_content_header_module_default()).image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/amazon-reward.png"),
                                                alt: "",
                                                height: 36,
                                                width: 36
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (search_content_header_module_default()).link,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "\xa320 Amazon voucher with every lease"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                                    href: routes/* ROUTES.rewardsAndReferralsPage.url */.Z.rewardsAndReferralsPage.url,
                                                    hierarchy: Button/* ButtonHierarchy.Bezeled */.B.Bezeled,
                                                    size: system/* Size.Medium */.$u.Medium,
                                                    children: "More about LocoRewards"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_content_header_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (search_content_header_module_default()).image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/wink-with-background.png"),
                                                alt: "",
                                                height: 36,
                                                width: 36
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (search_content_header_module_default()).link,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Road tax & breakdown cover included"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                                    href: routes/* ROUTES.whyLeasePage.url */.Z.whyLeasePage.url,
                                                    size: system/* Size.Medium */.$u.Medium,
                                                    hierarchy: Button/* ButtonHierarchy.Bezeled */.B.Bezeled,
                                                    children: "Learn more benefits of leasing"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/SearchContentHeader/index.ts



/***/ }),

/***/ 55863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ Faqs_Faqs; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/services/pageService.js
var pageService = __webpack_require__(63392);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/remove-markdown/index.js
var remove_markdown = __webpack_require__(26525);
var remove_markdown_default = /*#__PURE__*/__webpack_require__.n(remove_markdown);
// EXTERNAL MODULE: ./components/atomic/FaqAccordionItem/index.ts + 1 modules
var FaqAccordionItem = __webpack_require__(72201);
// EXTERNAL MODULE: ./components/atomic/Loader/index.ts + 1 modules
var Loader = __webpack_require__(54131);
;// CONCATENATED MODULE: ./components/atomic/Faqs/Faqs.js









var Faqs = function(param) {
    var vehicleType = param.vehicleType, status = param.status, faqList = param.faqList, activeFaqs = param.activeFaqs, setActiveFaqs = param.setActiveFaqs, title = param.title;
    var ref = (0,react.useState)(activeFaqs), preExpanded = ref[0], setPreExpanded = ref[1];
    (0,react.useEffect)(function() {
        setPreExpanded(activeFaqs);
    }, [
        activeFaqs
    ]);
    (0,react.useEffect)(function() {
        if (faqList.length > 0 && activeFaqs.length === 0) {
            setPreExpanded([
                faqList[0].slug
            ]);
        }
    }, [
        faqList,
        activeFaqs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE && faqList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    children: '\n              {\n                "@context": "https://schema.org",\n                "@type": "FAQPage",\n                "mainEntity": ['.concat(faqList.map(function(faq) {
                        return JSON.stringify({
                            "@type": "Question",
                            name: "".concat(faq.title),
                            acceptedAnswer: {
                                "@type": "Answer",
                                text: "".concat(remove_markdown_default()(faq.body))
                            }
                        });
                    }), "]\n              }\n            ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: title ? title : "".concat(vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "Van" : "Car", " Leasing FAQs")
                            }),
                            status === constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                            }),
                            status === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE && faqList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                                preExpanded: preExpanded,
                                onChange: function(value) {
                                    return setActiveFaqs(value);
                                },
                                children: faqList.map(function(faq) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqAccordionItem/* FaqAccordionItem */.Q, {
                                        item: faq,
                                        isActive: preExpanded.includes(faq.slug)
                                    }, faq.slug);
                                })
                            }),
                            status === constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert alert-warning my-3",
                                role: "alert",
                                children: "There has been an issue fetching the FAQs. Please try again later."
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/Faqs/index.js


;// CONCATENATED MODULE: ./components/views/Faqs/Faqs.js







var Faqs_Faqs = function(param) {
    var vehicleType = param.vehicleType, _serverFaqList = param.serverFaqList, serverFaqList = _serverFaqList === void 0 ? null : _serverFaqList, _title = param.title, title = _title === void 0 ? null : _title;
    var ref = (0,react.useState)(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)([]), faqList = ref1[0], setFaqList = ref1[1];
    var ref2 = (0,react.useState)(!!serverFaqList && serverFaqList.length > 0 ? [
        serverFaqList[0].slug
    ] : []), activeFaqs = ref2[0], setActiveFaqs = ref2[1];
    var fetchData = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(requestParams) {
            var response, list, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setStatus(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,pageService/* getPageContentListService */.oF)(requestParams)
                        ];
                    case 2:
                        response = _state.sent();
                        list = response.items[0].content.items.filter(function(faq) {
                            return faq.vehicleType === vehicleType;
                        });
                        setFaqList(list);
                        return [
                            2,
                            setStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE)
                        ];
                    case 3:
                        err = _state.sent();
                        if (err.status === 404) {
                            return [
                                2,
                                setStatus(constants/* constants.componentStatus.NOT_FOUND */._G.componentStatus.NOT_FOUND)
                            ];
                        } else {
                            return [
                                2,
                                setStatus(constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR)
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(requestParams) {
            return _ref.apply(this, arguments);
        };
    }(), [
        vehicleType
    ]);
    (0,react.useEffect)(function() {
        if (serverFaqList === null) {
            var requestParams = {
                type: "FAQ_DEAL_PAGE",
                page: "1"
            };
            fetchData(requestParams);
        } else {
            setFaqList(serverFaqList);
            setStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE);
        }
    }, [
        vehicleType,
        serverFaqList,
        fetchData
    ]);
    (0,react.useEffect)(function() {
        if (faqList.length > 0) {
            setActiveFaqs([
                faqList[0].slug
            ]);
        }
    }, [
        faqList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs, {
        vehicleType: vehicleType,
        status: status,
        faqList: faqList,
        activeFaqs: activeFaqs,
        setActiveFaqs: setActiveFaqs,
        title: title !== null ? title : "In case you missed anything."
    });
};

;// CONCATENATED MODULE: ./components/views/Faqs/index.js



/***/ }),

/***/ 63392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ getCustomerTestimonialsService; },
/* harmony export */   "oF": function() { return /* binding */ getPageContentListService; }
/* harmony export */ });
/* unused harmony exports getAdvancedLandingPageDealService, getPageContentItemService, getFaqArticleContentService, getCareersContentService */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19931);
/* harmony import */ var _restService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39177);





var getAdvancedLandingPageDealService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(adReference) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.advancedLandingPageDeal */ .l.advancedLandingPageDeal, {
                            adReference: adReference
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAdvancedLandingPageDealService(adReference) {
        return _ref.apply(this, arguments);
    };
}();
var getPageContentListService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.pageContentList */ .l.pageContentList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPageContentListService(params) {
        return _ref.apply(this, arguments);
    };
}();
var getPageContentItemService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.pageContent */ .l.pageContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPageContentItemService(params) {
        return _ref.apply(this, arguments);
    };
}();
var getFaqArticleContentService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.faqArticles */ .l.faqArticles)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getFaqArticleContentService() {
        return _ref.apply(this, arguments);
    };
}();
var getCareersContentService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.careers */ .l.careers)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCareersContentService() {
        return _ref.apply(this, arguments);
    };
}();
var getCustomerTestimonialsService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.testimonials */ .l.testimonials)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCustomerTestimonialsService() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 21503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(638);
/* harmony import */ var _components_styleguide_SearchContentHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40971);
/* harmony import */ var _components_views_Faqs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55863);
/* harmony import */ var _components_views_SearchResultsAndFilters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2374);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99280);
/* harmony import */ var _store_reducers_search__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29109);
/* harmony import */ var _store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56664);












var VanSearchPage = function(param) {
    var faqList = param.faqList, pageContent = param.pageContent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), showPageContent = ref1[0], setShowPageContent = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING);
        if (router.query.page) {
            dispatch((0,_store_reducers_search__WEBPACK_IMPORTED_MODULE_10__/* .storePageNumber */ .Sp)(Number(router.query.page)));
            setShowPageContent(false);
        } else {
            dispatch((0,_store_reducers_search__WEBPACK_IMPORTED_MODULE_10__/* .landedOnVanSearchPage */ .ST)(router.asPath));
        }
    }, [
        router.query.page,
        router.asPath,
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_11__/* .clearSelectedPaintOption */ .ny)());
        dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_11__/* .clearPaintOptionVehicle */ .sO)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_4__/* .PageMetaData */ .S, {
                title: "Compare Van Lease Deals | Van Leasing Comparison | LeaseLoco",
                pageTitle: "Compare Van Lease Deals | Van Leasing Comparison | LeaseLoco",
                description: "Search and compare the best van lease deals on the market with LeaseLoco. Van leasing comparison that instantly finds and ranks the best deals for you!",
                pageUrl: router.asPath.split("?")[0],
                canonical: "".concat("https://www.leaseloco.com").concat(router.asPath.split("?")[0]),
                image: _lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .constants.imageHost.social */ ._G.imageHost.social
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Header__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h, {
                isVans: true,
                backgroundColor: "backdrop",
                width: "browse",
                hideNav: "mobile"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_SearchResultsAndFilters__WEBPACK_IMPORTED_MODULE_8__/* .SearchResultsAndFilters */ .Q, {
                setStatus: setStatus,
                isVans: true,
                status: status
            }),
            showPageContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_SearchContentHeader__WEBPACK_IMPORTED_MODULE_6__/* .SearchContentHeader */ .v, {
                isVans: true,
                pageContent: pageContent,
                showBreadcrumbs: false,
                showLinks: false,
                isBottom: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "container-fluid container--config-faqs",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "config-page__faqs",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_Faqs__WEBPACK_IMPORTED_MODULE_7__/* .Faqs */ .q, {
                        vehicleType: _lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .FILTER_VEHICLE_TYPES_VANS */ .Bz,
                        serverFaqList: faqList
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (VanSearchPage);


/***/ }),

/***/ 11783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"breadcrumbs_main__VBByA","crumbs":"breadcrumbs_crumbs__pJ96J","crumb":"breadcrumbs_crumb__NOO8e","phAnimation":"breadcrumbs_phAnimation__MNg6t"};

/***/ }),

/***/ 85033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-content-header_main__W3_qs","bottom":"search-content-header_bottom__y7_Cy","wrapper":"search-content-header_wrapper__Lq1x5","content":"search-content-header_content__WNXr_","markdown":"search-content-header_markdown__vB5sK","show":"search-content-header_show__5gMms","button":"search-content-header_button__naud0","links":"search-content-header_links__CUHe2","item":"search-content-header_item__y7tGO","image":"search-content-header_image__peECC","link":"search-content-header_link__kOQlw","body":"search-content-header_body__UvcSl","phAnimation":"search-content-header_phAnimation__dX2dC"};

/***/ }),

/***/ 50997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-breadcrumbs_main__tCJaY","phAnimation":"search-breadcrumbs_phAnimation__81ydH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2302,1852,5675,4660,8611,8456,535,1876,111,638,1429,3052,9758,9774,2888,179], function() { return __webpack_exec__(13815); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);